import { initSubRoutes } from '../../../../utils/router';

const RoutesChangementResponsableLegalReinitialisation = initSubRoutes({
    route: '/reinitialisation/:uuidHistorique',
    subroutes: {},
    nom: 'Réinitialisation des identifiants - Changement RL',
});

export default RoutesChangementResponsableLegalReinitialisation;
